import { Clock3, MapPin, Phone } from 'lucide-react'
import { LeadForm } from '../components/LeadForm'
import { site } from '../content/site'

export function ContactPage() {
  return (
    <section className="contact-page">
      <div className="shell contact-page__intro">
        <div>
          <p className="eyebrow eyebrow--light">Talk to an aquarium specialist</p>
          <h1>Show us the space. Or show us the problem.</h1>
          <p>
            Brian can quickly assess many aquarium needs by phone, email, and a few useful photos. Share what you know; we’ll help identify the next step.
          </p>
        </div>
        <div className="contact-page__facts">
          <a href={site.phoneHref}><Phone aria-hidden="true" /><span><small>Call anytime</small>{site.phoneDisplay}</span></a>
          <p><Clock3 aria-hidden="true" /><span><small>Typical follow-up</small>Within one business day</span></p>
          <p><MapPin aria-hidden="true" /><span><small>Service area</small>Santa Barbara to San Diego</span></p>
        </div>
      </div>
      <div className="contact-page__image">
        <img src="/images/optimized/contact-page.webp" alt="Colorful mature reef aquarium" />
      </div>
      <div className="shell contact-page__form">
        <aside>
          <p className="eyebrow">Before you send</p>
          <h2>Useful photos include:</h2>
          <ul>
            <li>The full aquarium and surrounding room</li>
            <li>Filtration, plumbing, and equipment</li>
            <li>The exact leak, damage, algae, or livestock concern</li>
          </ul>
          <p>For an active leak or livestock emergency, call first.</p>
        </aside>
        <LeadForm />
      </div>
    </section>
  )
}
